import { render } from "./Modal.vue?vue&type=template&id=04ae0d48"
const script = {}

import "./Modal.vue?vue&type=style&index=0&id=04ae0d48&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__